export const theme = {
  breakpoints: {
    mobile: 480,
    tablet: 800,
    desktop: 1200,
    all: Infinity
  },
  rowGap: 24
}
